/** Yes/no strings sent by confirmation cards — must not pass through Nova Lite rewrite. */

function normalizeForMatch(text: string): string {
  let t = (text || '')
    .normalize('NFD')
    .replace(/\u0300-\u036f/g, '')
    .toLowerCase()
  t = t.replace(/[^\w\s]/g, ' ')
  return t.replace(/\s+/g, ' ').trim()
}

const FR_CONTINUE_STEM = 'continu(?:er|e|es)?'

/** Mirrors backend ``remind_me_intent._is_yes_proceed`` / card click payloads. */
export function isBinaryConfirmYesPhrase(text: string): boolean {
  const t = normalizeForMatch(text)
  if (!t) return false
  if (
    new RegExp(
      `^(yes|yeah|yep|ok|okay|proceed|confirm|continue|yes\\s+proceed(?:\\s+please)?|yes\\s+continue(?:\\s+please)?|yes\\s+open|oui|oui\\s+${FR_CONTINUE_STEM}|oui\\s+proceder|oui\\s+ouvrir|${FR_CONTINUE_STEM}|confirme|confirmer|valider|d\\s*accord|c\\s*est\\s+bon|parfait|entendu|allez\\s*y|vas\\s*y|bien\\s+sure)$`,
      'i',
    ).test(t)
  ) {
    return true
  }
  if (/^(yes|yeah|yep|oui|ok|okay|sure)\s+proceed(\s+please)?(\s+\S+)*$/i.test(t)) {
    return true
  }
  if (/^(yes|yeah|yep|oui|ok|okay|sure)\s+continue(\s+please)?(\s+\S+)*$/i.test(t)) {
    return true
  }
  if (/^(yes|yeah|yep|oui)\s+open(\s+\S+)*$/i.test(t)) {
    return true
  }
  return false
}

/** Mirrors backend ``remind_me_intent._is_no_cancel`` / card click payloads. */
export function isBinaryConfirmNoPhrase(text: string): boolean {
  const t = normalizeForMatch(text)
  if (!t) return false
  if (/^(no|nope|cancel|stop|abort|no\s+cancel|non|annule|annuler|non\s+annuler|non\s+annule)$/.test(t)) {
    return true
  }
  return /^(non\s+annul(?:er|e)|no\s+cancel)$/.test(t)
}

/** Sports NOC / mail send confirmation card payloads (must not pass through Nova Lite). */
export function isMailSendConfirmPhrase(text: string): boolean {
  const t = normalizeForMatch(text)
  if (!t) return false
  if (
    /^(envoyer|envoyez|send(\s+it)?|mail(\s+it)?|email(\s+it)?|e\s*mail(\s+it)?|yes\s+send(\s+(it|the\s+mail|mail))?|oui\s+envoyer(\s+(le\s+)?(courriel|mail|e\s*mail))?)$/i.test(
      t,
    )
  ) {
    return true
  }
  return /^(no\s+cancel(\s+(mail|it))?|non\s+annuler(\s+(le\s+)?(courriel|mail|e\s*mail))?|ne\s+pas\s+envoyer|do\s+not\s+send)$/i.test(
    t,
  )
}

export function isBinaryInteractiveConfirmPhrase(text: string): boolean {
  return (
    isBinaryConfirmYesPhrase(text) ||
    isBinaryConfirmNoPhrase(text) ||
    isMailSendConfirmPhrase(text)
  )
}
